import { render } from "./TemplateEditModal.vue?vue&type=template&id=2c931e83"
import script from "./TemplateEditModal.vue?vue&type=script&lang=js"
export * from "./TemplateEditModal.vue?vue&type=script&lang=js"
script.render = render

export default script